// External imports
import NextLink from "next/link";

// Local imports
import classes from "./style.module.css";
import languageConfig from "@/export/config";
import DownloadIcon from "@/app/assets/vectors/DownloadIcon";

// Component props for Item
interface Props {
  url: string;
  downloadPath: string;
  titleEn: string;
  titleMl: string;
  text: string;
  cssName: string;
}

export default function Item({
  url,
  downloadPath,
  titleEn,
  titleMl,
  text,
  cssName,
}: Props) {
  return (
    <div className={`${classes.card}`}>
      <NextLink
        href={
          text === languageConfig?.routes.fonts?.input.textOptions[0]
            ? `/fonts/${url}`
            : `/fonts/${url}#${text}`
        }
        className={classes.fontLink}
      >
        <div className={`${classes.cardTitle}`}>
          {titleEn} <span>| {titleMl}</span>
        </div>

        <div className={`${classes.cardPreview}`}>
          <div>
            <p
              style={{
                fontFamily: cssName,
              }}
            >
              {text || "Type something..."}
            </p>
          </div>
        </div>
      </NextLink>

      <NextLink
        href={`${downloadPath}`}
        download
        className={classes.downloadLink}
      >
        <DownloadIcon color="var(--clr-white)" />
      </NextLink>
    </div>
  );
}
